var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class ShapeColumn extends Component {
    constructor() {
        super('ShapeColumn', false);
        this.windowWidthReference = 0;
        this.referenceHeight = 0;
        this.success();
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // If window width change from 992px to 991px or vice versa, we need to recalculate the number of shapes to add
            $(window).on('resize', () => {
                const windowWidth = $(window).width();
                if (windowWidth >= 992 && this.windowWidthReference < 992) {
                    this.fillShapes();
                }
                else if (windowWidth < 992 && this.windowWidthReference >= 992) {
                    this.fillShapes();
                }
                this.windowWidthReference = windowWidth;
            });
            setTimeout(() => {
                this.fillShapes();
            }, 100);
            this.success();
        });
    }
    fillShapes() {
        let titleHeight = 0;
        $('.component-shape-column__title').each((title) => {
            if (title.height() > titleHeight) {
                titleHeight = title.height();
            }
        });
        this.referenceHeight = titleHeight / 1;
        $('.component-shape-column').each((column) => {
            column.find('.shape--filler ').remove();
            const columnHeight = column.height() - column.find('.component-shape-column__title').height() - column.find('.component-shape-column__link').height();
            let shapeToAdd = Math.floor(columnHeight / this.referenceHeight);
            if (shapeToAdd < 1)
                shapeToAdd = 1;
            if (shapeToAdd === 1 && column.height() - column.find('.component-shape-column__title').height() - column.find('.component-shape-column__link').height() < 48) {
                $(column.find('.component-shape-column__title').addClass('flex-grow-1'));
            }
            else {
                for (let i = 0; i < shapeToAdd; i++) {
                    const shape = $.parseHTML('<div class="shape shape--c shape--filler flex-grow-1 bg-white"></div>');
                    column.find('.component-shape-column__title').after(shape);
                }
            }
        });
        let shapeSequence = 0;
        const shapesSuffixes = ['i', 'd', 'c'];
        $('.component-shape-column .shape:not(.ignore-shape-sequence').each((shape) => {
            shape.removeClass('shape--i shape--d shape--c');
            shape.addClass(`shape--${shapesSuffixes[shapeSequence++ % 3]}`);
        });
    }
}
